module.exports = __webpack_public_path__ + "img/icon-fom-search-for-form.539849b5.png";